import { gql } from "@apollo/client";

export const GET_ENVIO_INSUMOS = gql`
  query GetEnvioInsumos(
              $idOrdenPedido: Int!, 
              $idEvaluacion: Int!,
              $fechaDesde: CustomDateTime!,
              $fechaHasta: CustomDateTime!) {
    envioInsumos(
          idOrdenPedido: $idOrdenPedido, 
          idEvaluacion: $idEvaluacion,
          fechaDesde: $fechaDesde,
          fechaHasta: $fechaHasta
          ) {      
      idInsumoN,
      idInsumo,
      descripcion,
      por,
      cantidadPlan,
      cantidadDiaria,
      cantidadAPedir,
      indFutura
    }
  }
`;